export default "__VITE_ASSET__BLXdWppr__"